var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOutlook = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.5h-7a.5.5 0 0 0 0 1h5.543l-3.072 2.389-2.203-1.401-.536.844 2.5 1.59a.497.497 0 0 0 .575-.027L15 5.022V11.5H8.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.408.51A.5.5 0 0 1 9 1v14a.5.5 0 0 1-.592.49l-8-1.5a.499.499 0 0 1-.408-.49v-11c0-.241.171-.447.408-.491l8-1.5ZM4.5 5.5C3.122 5.5 2 6.846 2 8.5s1.122 3 2.5 3S7 10.154 7 8.5s-1.122-3-2.5-3Zm0 1c.827 0 1.5.897 1.5 2s-.673 2-1.5 2S3 9.603 3 8.5s.673-2 1.5-2Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff"
  })))));
};
export { SvgOutlook as ReactComponent };